import React from 'react';
import cn from 'classnames';
import styles from './Row.module.sass';
import Control from '../../../../components/Control';
import Switch from '../../../../components/Switch';

const Row = ({ item, onEdit, onDelete, onStatusChange }) => {
    // Comme nous récupérons directement les users, pas besoin d'expand
    const userData = item.expand?.user_id || item; // Fallback sur item si pas d'expand
    
    console.log('🔍 Row - item:', item);
    console.log('🔍 Row - userData:', userData);
    console.log('🔍 Row - status:', userData.status, typeof userData.status);
    
    const actions = [
        {
            icon: 'edit',
            action: () => onEdit(item),
        },
        {
            icon: 'trash',
            action: () => onDelete(item.id),
        },
    ];

    const handleStatusChange = (newStatus) => {
        if (onStatusChange) {
            onStatusChange(item, newStatus);
        }
    };

    return (
        <tr className={styles.row}>
            <td className={styles.col}>
                <div className={styles.item}>
                    <div className={styles.preview}>
                        <img src="/images/content/tutor_logo.png" alt="Tutor" />
                    </div>
                    <div className={styles.details}>
                        <div className={styles.name}>{item.first_name} {item.last_name}</div>
                        <div className={styles.email}>{userData.email}</div>
                    </div>
                </div>
            </td>
            <td className={styles.col}>
                <div className={styles.entity}>
                    {userData.entity || <span style={{ color: '#999', fontStyle: 'italic' }}>-</span>}
                </div>
            </td>
            <td className={styles.col}>
                <div className={styles.role}>
                    {Array.isArray(userData.role) ? (
                        userData.role.map((role, index) => {
                            let statusClass = '';
                            
                            // Attribution des classes de status selon le rôle
                            switch(role) {
                                case 'Admin':
                                    statusClass = 'status-blue';
                                    break;
                                case 'Commercial':
                                    statusClass = 'status-green';
                                    break;
                                case 'Pedagogical':
                                    statusClass = 'status-purple';
                                    break;
                                default:
                                    statusClass = 'status-gray';
                            }
                            
                            return (
                                <span key={index} className={statusClass} style={{ marginRight: '5px', marginBottom: '5px', display: 'inline-block' }}>
                                    {role}
                                </span>
                            );
                        })
                    ) : (
                        <span className="status-gray">{userData.role || 'Non spécifié'}</span>
                    )}
                </div>
            </td>
            <td className={styles.col}>
                <Switch value={userData.status} onChange={handleStatusChange} />
            </td>
            <td className={styles.col}>
                <Control actions={actions} />
            </td>
        </tr>
    );
};

export default Row;
